import { useMembersContext } from '@/contexts/membersContext';
import { InsuranceProviderParams } from '@/pages/members/hooks/useInsuranceProviders';
import { InsuranceProvider } from '@/types/insuranceProvider';
import ajax from '@/utils/ajax';

export const insuranceProviderRepository = {
  BASE_PATH: '/api/insurance/insurance_options/providers/',

  async list({
    host,
    params
  }: {
    host: string;
    params?: InsuranceProviderParams;
  }): Promise<InsuranceProvider[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`,
      params: {
        ...params
      }
    });

    return response.data;
  }
};

export const InsuranceProviderRepository = () => {
  const { host } = useMembersContext();

  return {
    async list(params: InsuranceProviderParams) {
      return insuranceProviderRepository.list({ host, params });
    }
  };
};
